import { LocationMatrixHelper } from "@swivl-mono/helpers";
import { LocationScope, MemberInterface, MemberInviteInterface, MemberPermission } from "@swivl-mono/types";
import { Panel, Spinner, Switch } from "@swivl-mono/ui";

import LocationsModel from "../../../../../Models/Locations/Locations.Model";

interface OptionProps {
  on: boolean;
  label: any;
  indent: string;
  onChange: (event: any) => void;
}
function MemberPermissionsScopePanelOption(props: OptionProps) {
  return (
    <div className="flex flex-row w-full mb-3">
      <div className={"flex-1 " + props.indent}>{props.label}</div>
      <div className="flex col">
        <Switch on={props.on} onChange={props.onChange} />
      </div>
    </div>
  );
}

interface Props {
  memberOrInvite: MemberInterface | MemberInviteInterface;
  memberPermission: MemberPermission;
  updatePermissions(updated: MemberPermission): void;
}

export function MemberPermissionsScopePanel(props: Props) {
  const { memberOrInvite, memberPermission } = props;
  const { groups } = LocationsModel.useState();
  const locations = memberPermission.locations || {};
  let message = "";

  const orgWide = locations.orgId === memberOrInvite.orgId;

  if (orgWide) {
    message = "All Locations";
  } else if (groups) {
    let locationsEnabled = 0;
    Object.values(groups).map((group) => {
      if (locations.groupIds?.includes(group.id)) {
        locationsEnabled += group.locations.length;
      } else if (group.locations) {
        locationsEnabled += group.locations.filter((location) => locations.locationIds?.includes(location.id)).length;
      }
    });
    message = `${locationsEnabled} locations enabled`;
  } else {
    message = "No locations enabled";
  }
  if (!groups) {
    return <Panel style={Panel.Style.GREY} header={<Spinner />} />;
  }

  return (
    <Panel style={Panel.Style.GREY} header={message}>
      <div className="flex flex-col">
        <MemberPermissionsScopePanelOption
          key="all"
          on={orgWide}
          label="All"
          indent=""
          onChange={(event) => {
            props.updatePermissions({
              ...memberPermission,
              locations: LocationMatrixHelper.updateMatrix(
                event.target.checked,
                LocationScope.ORG,
                memberOrInvite.orgId,
                memberPermission.locations,
                groups,
              ),
            });
          }}
        />
        {groups &&
          Object.values(groups).map((group) => {
            const groupWide = locations.groupIds?.includes(group.id) ? true : false;

            return (
              <div key={"container-" + group.id}>
                <MemberPermissionsScopePanelOption
                  on={orgWide || groupWide}
                  label={group.name}
                  key={"group-" + group.id}
                  indent="pl-4"
                  onChange={(event) => {
                    props.updatePermissions({
                      ...memberPermission,
                      locations: LocationMatrixHelper.updateMatrix(
                        event.target.checked,
                        LocationScope.GROUP,
                        group.id,
                        memberPermission.locations,
                        groups,
                      ),
                    });
                  }}
                />
                {group.locations.map((location) => {
                  const locationWide = locations.locationIds?.includes(location.id) ? true : false;

                  return (
                    <MemberPermissionsScopePanelOption
                      on={orgWide || groupWide || locationWide}
                      label={<>{location.name} </>}
                      indent="pl-8"
                      key={"location-" + location.id}
                      onChange={(event) => {
                        props.updatePermissions({
                          ...memberPermission,
                          locations: LocationMatrixHelper.updateMatrix(
                            event.target.checked,
                            LocationScope.LOCATION,
                            location.id,
                            memberPermission.locations,
                            groups,
                          ),
                        });
                      }}
                    />
                  );
                })}
              </div>
            );
          })}
      </div>
    </Panel>
  );
}
